import React from 'react';
import DateSquare from './DateSquare';
import JobDot from './JobDot';
import Money from '../../../../Components/Formatting/Money';
import { classNames } from '../../../../Services/helpers';
import { statuses } from '../../../../Data/Jobs';

const Compact = ({today, dates, setExpanded}) => {
    return <div className="w-full flex flex-row divide-x">
        {Object.keys(dates).map(date => <Day key={date} {...{date, data: dates[date], today, setExpanded}} />)}
    </div>
}

const Day = ({date, today, data, setExpanded}) => {
    const jobs = [
        ...data.scheduled.jobs.map((job) => job),
        ...data.scheduled.rounds.reduce((agg, round) => [...agg, ...round.jobs], []),
    ];
    const suggestions = [
        ...data.suggested.jobs.map((job) => job),
        ...data.suggested.rounds.reduce((agg, round) => [...agg, ...round.jobs], []),
    ];
    const total = jobs.reduce(
        (agg, job) => statuses?.[job.status]?.excludeFromTotals ? agg : agg + job.cost,
        0
    );

    const sorted = jobs.sort((a, b) => `${a.status}${a.duration ?? '00:15:00'}` > `${b.status}${b.duration ?? '00:15:00'}` ? -1 : 1);

    return <div className="grow flex flex-col items-center justify-between gap-y-3">
        <div className={classNames(
            'grow flex flex-col-reverse items-center gap-y-px',
            jobs.length === 0 && 'justify-center'
        )}>
            {sorted.map(job => <JobDot key={job.id} job={job} compact />)}
            {jobs.length === 0 && <div className="shrink my-3 text-muted">-</div>}
        </div>
        <DateSquare {...{today, date}} onClick={() => setExpanded(true)} ring={suggestions.length > 0} />
        <Money pence={total} className="text-xs text-muted" hidePence />
    </div>
}


export default Compact;